import {Map} from 'immutable';
import {addToShortlist, removeFromShortlist, setShortlistData} from './core';
import {cache} from 'locache';

export const INITIAL_STATE = Map({
    shortlist: cache('shortlist').get() || {}
});

export default function reducer(state = Map({}), action) {
    switch (action.type) {
        case 'ADD_TO_SHORTLIST' :
            return addToShortlist(state, action.payload.id);
        case 'REMOVE_FROM_SHORTLIST' :
            return removeFromShortlist(state, action.payload.id);
        case 'SET_SHORTLIST_DATA' :
            return setShortlistData(state, action.payload.shortlistData);
    }
    return state;
}
